import {
	UPDATE_SELECTED_PAYMENT_OPTION,
	UPDATE_EMI_CARD_PAYMENT_OPTION,
	INSTRUMENT_CHECK_SUCCESS,
	INSTRUMENT_CHECK_RESET,
	EMI_TENURES_SUCCESS
} from 'actions/PaymentActions/PaymentActions';
import { ActionType } from 'actions/PaymentActions/EMIonSavedCardActions';
import { UPDATE_EMI_TENURE } from 'actions/PaymentActions/emiStateActions';
import { getTenureKey } from 'actions/PaymentActions/utils/tenures';
import get from 'lodash/get';

export const INITIAL_STATE = {};

export default function adjustments(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case UPDATE_EMI_CARD_PAYMENT_OPTION:
		case UPDATE_SELECTED_PAYMENT_OPTION:
		case INSTRUMENT_CHECK_RESET:
			return INITIAL_STATE;
		case INSTRUMENT_CHECK_SUCCESS:
			return get(action.data, ['adjustments']) || {};
		case EMI_TENURES_SUCCESS:
			// Hack! Emi tenures success will happen when user switches between
			// the EMI section, but not when they switch between tenures. The
			// flow of events when, for example, user went from no cost EMI to
			// EMI with Interest section:
			//
			// 1. UPDATE_EMI_SECTION
			// 2. UPDATE_EMI_BANK
			// 3. EMI_TENURES_SUCCESS
			//
			// Sequence of events when user switches to a different tenure
			// under the current section:
			//
			// 1. UPDATE_EMI_TENURE
			//
			// So to update the adjustments reducer in both of these scenarios,
			// we should cover both these cases.
			//
			// Another assumption is around the selected tenure. In the current
			// buggy implementation, the tenure doesn't change when user goes
			// from No Cost to EMI with Interest since emiState is a sigleton
			// object, and doesn't maintain per-section history. So here we
			// pick the tenure directly from the emi state.
			//
			//
			// A proper fix for this would be to ensure we store the
			// per-section history of the selection, and use that structure to
			// determine the adjustments.
			const currentMonth = get(action, ['emiState', 'selectedTenure']);
			return get(action, ['data', 'emi_scheme_adjustments', currentMonth], {});
		case UPDATE_EMI_TENURE:
			const emiState = get(action, ['paymentsState', 'emiState']) || {};
			const key = getTenureKey(emiState);
			return get(action, ['paymentsState', 'emiTenures', key, 'emi_scheme_adjustments', action.tenure], {});
		case ActionType.EMI_ON_SAVED_CARD_TENURE_CHANGED:
			return action.adjustments;
		default:
			return state;
	}
}
